import { Component, OnInit, AfterViewInit, HostListener, Output, EventEmitter, Input, Inject } from '@angular/core';
import { environment } from '../../environments/environment';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-connectwise-handler',
  template: ''
})
export class ConnectwiseHandlerComponent implements OnInit, AfterViewInit {
  @Input() debug = false;
  @Output() eventHandler: EventEmitter<any> = new EventEmitter();
  loaded = false;
  _frameId: any;
  ORIGIN: string;

  constructor (@Inject(DOCUMENT) private document) {
    if (document.referrer) {
      const strArray = document.referrer.split('//');
      this.ORIGIN = `${strArray[0]}//` + strArray[1].split('/')[0];
      this.log(this.ORIGIN);
    }
  }

  @HostListener('window:message', ['$event'])
  onWindowMessage(event) {
    if (event.origin != this.ORIGIN) {
      this.log('origin does not match', event.origin);
      return;
    }

    try {
      if (event.data) {
        const jsonMsg = JSON.parse(event.data);
        this.log('onWindowMessage JSON', jsonMsg);

        if(jsonMsg.MessageFrameID) {
          this.log('setting frameID to ' + jsonMsg.MessageFrameID);
          this._frameId = jsonMsg.MessageFrameID;
          return;
        }

        if (jsonMsg.event == 'onLoad') {
          this.postMessage({request : 'getMemberAuthentication'});
        }
        this.eventHandler.emit(jsonMsg);
      }
    } catch (err) {
      this.log('Could not parse message', event);
    }
  }

  ngOnInit() {
  }

  ngAfterViewInit() {
    this.postMessage({message: 'ready'});
  }

  postMessage(message) {
    // if ((parent instanceof Window) && !(<any>parent).origin.includes("connectwise")) {
    //   this.eventHandler.emit({error: 'INVALID_ORIGIN'});
    // } else {
      // need to pre-pend hosted_ to request to avoid confusion with vendor hosted api.
      message.hosted_request = message.request;
      delete message.request;

      if (this._frameId) {
        message.frameID = this._frameId;
      }
      this.log('postMessage', JSON.stringify(message), this.ORIGIN);
      parent.postMessage(JSON.stringify(message), this.ORIGIN);
    // }
  }

  log(logMsg, ...args) {
    if (this.debug) {
      console.log(logMsg, args);
    }
  }
}
